import doc                    from '@widesk-core/decorators/doc';
import model                  from '@widesk-core/decorators/model';
import TimestampAble          from '@widesk-core/models/traits/TimestampAble';
import Blamable               from '@/models/traits/Blamable';
import FondationsServiceModel from '@/models/FondationsServiceModel';

@model.cacheDuration()
@model.urnResource('entity_status')
@doc.path('/entity_statuses/{?id}')
export default class EntityStatusModel extends Blamable(TimestampAble(FondationsServiceModel)) {
	@doc.string declare name: Fondations_EntityStatusReference;
	@doc.string declare label: string;
	@doc.string declare reference: Fondations_EntityStatusReference;
	@doc.number declare value: number;

	public get color() {
		switch (this.reference) {
			case 'ENABLED':
				return 'green';
			case 'DISABLED':
				return 'red';
			case 'BLACKLISTED':
				return 'black';
		}
	}
}
